export const getOptionRoutes = function(opts = {}) {

    return {
        path: opts.path,
        name: `${opts.routeNamePrefix}`,
        redirect: { name: `${opts.routeNamePrefix}List` },
        meta: {
            title: opts.entitiesTitle,
            hideChildren: true,
        },
        component: {
            template: '<router-view></router-view>'
        },
        children: [{
                path: '',
                name: `${opts.routeNamePrefix}List`,
                meta: {
                    trans: 'global.list',
                    title: opts.entitiesTitle,
                    ...opts,
                },
                component: () => import('@views/app/option/index.vue'),
            },
            {
                path: 'add',
                name: `${opts.routeNamePrefix}Add`,
                meta: {
                    trans: 'global.add',
                    title: opts.entityTitle,
                    ...opts,
                },
                component: () => import('@views/app/option/add.vue'),
            },
            {
                path: ':uuid/edit',
                name: `${opts.routeNamePrefix}Edit`,
                meta: {
                    trans: 'global.edit',
                    title: opts.entityTitle,
                    ...opts,
                },
                component: () => import('@views/app/option/edit.vue'),
            },
        ]
    }
}
